import $http from './http'
import config from './config'

export default {
  name: 'flightpolicy',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getFlightLists(data) {
    return $http.post(this.getUrl(`/FlightSearch/Search`), data);
  },
  SaveFlight(data) {
    return $http.post(this.getUrl(`/FlightSearch/SaveFlight`), data);
  },
  getProductInfo(data) {
    return $http.post(this.getUrl('/FlightPolicy/ProductInfo'), data);
  },
  SearchAmendPolicy(id, applyarea) {
    // return $http.get(this.getUrl(`/AmendPolicy/GetAmendPolicy?id=${id}&ApplyArea=${applyarea}`), {
    //   failTips: false
    // })
    return $http.get(this.getUrl(`/Product/RuleInfo?id=${id}&ApplyArea=${applyarea}`), {
      failTips: false
    })
  },
  getCreatePolicy(data) {
    return $http.post(this.getUrl('/FlightPolicy/CreatePolicy'), data)
  },
  getProductList(data) {
    return $http.post(this.getUrl('/product/list'), data);
  },
  getProductGoods(data) {
    return $http.post(this.getUrl(`/product/GetGoods`), data);
  },
  searchPolicyRate(id, data) {
    return $http.post(this.getUrl(`/AmendPolicy/CalcPrice/${id}`), data);
  },
  GetChangeOrderPrice(data) {
    return $http.post(this.getUrl('/amendpolicy/GetChangeOrderPrice'), data)
  },
}



// WEBPACK FOOTER //
// ./src/apis/flightPolicyApi.js